import { EntraConnectionDto } from "../../../../autogen/bff-api";

export const hasEverSynced = (
  connection: Pick<EntraConnectionDto, "groups">,
): boolean => connection.groups.length > 0;
